// extracted by mini-css-extract-plugin
export default {"segments_container":"segments-page_segments_container__R-CIq","segment_show_search":"segments-page_segment_show_search__jpvsd"};